import { CommonResponse } from "@gtpl/shared-models/masters";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post, Req } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { LocationById } from "./dto/locaion-get-by-id.dto";
import { LocationDTO } from "./dto/location-dto";
import { LocationByIdReq } from "./dto/location-id-request";
import { LocationService } from "./locations.service";
import { LocationByPlant } from "./dto/location-by-plant.dto";

@ApiTags('location')
@Controller('location')
export class LocationController {
    
    constructor(private locationService: LocationService, 
        private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }

    @Post('/create')
    async create(@Body() locationDTO: LocationDTO): Promise<CommonResponse> {
        try {
            return await this.locationService.create(locationDTO);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getAllAssetsLocations')
    async getAllAssets(@Body() req?: LocationByPlant): Promise<CommonResponse> {
        try {
            return await this.locationService.getAllAssets(req)
        } catch(error) {
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }

    @Post('/activateOrDeactivate')
    async activateOrDeactivate(@Body() req: LocationByIdReq): Promise<CommonResponse> {
        try {
            return await this.locationService.activateOrDeactivate(req)
        } catch(error) {
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }

    @Post('/updateLocation')
    async update(@Body() req: LocationDTO): Promise<CommonResponse> {
        try {
            return await this.locationService.update(req)
        } catch(error) {
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }

   @Post('/getById')
   async getById(@Body() req: LocationById): Promise<CommonResponse> {
    try {
        return await this.locationService.getById(req)
    } catch(error) {
        return this.applicationExceptionHandler.returnException(CommonResponse,error)
    }
   }

   @Post('/getLocationByPlant')
   async getLocationByPlant(@Body() req: LocationByPlant): Promise<CommonResponse> {
    try {
        return await this.locationService.getLocationByPlant(req)
    } catch(error) {
        return this.applicationExceptionHandler.returnException(CommonResponse,error)
    }
   }

   @Post('/getAssetsCountByLocations')
   async getAssetsCountByLocations(@Body() req: LocationById): Promise<CommonResponse> {
    try {
        return await this.locationService.getAssetsCountByLocations(req)
    } catch(error) {
        return this.applicationExceptionHandler.returnException(CommonResponse,error)
    }
   }
}
